// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@awc/App/Store/Reducers";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

// XNG-Change: add notes and account number to cart
export const XngPopulateApiParameter: any = (props: any) => {
    if (!props.cartToUpdate) {
        return;
    }

    const currentState = (props.getState() as CustomAppState);
    const editedCartNotes = currentState.pages.checkoutShipping.editedCartNotes;
    const useShippingAccountNumber = currentState.xCheckout.shipping.useShippingAccountNumber;
    const shippingAccountNumber = currentState.xCheckout.shipping.shippingAccountNumber;

    props.apiParameter = {
        ...props.apiParameter,
        cart: {
            ...props.apiParameter?.cart,
            notes: editedCartNotes,
            properties: {
                ...props.apiParameter?.cart?.properties,
                useShippingAccountNumber,
                shippingAccountNumber,
            }
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
